export default __webpack_public_path__ + "static/media/logo-gnp.c435eb92.svg";